module.exports = __webpack_public_path__ + "img/_vrbo_logo.cb84570f.svg";